import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuthStore } from '@/store/auth.store';

export function ImpersonationBanner() {
  const { user, isImpersonating, stopImpersonation } = useAuthStore();
  const navigate = useNavigate();

  if (!isImpersonating) return null;

  const handleExit = () => {
    stopImpersonation();
    navigate('/app/admin/users');
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <AlertTriangle className="h-4 w-4 shrink-0" />
          <p className="text-sm font-medium">
            Ești autentificat ca {user?.firstName} {user?.lastName} ({user?.email})
          </p>
        </div>
        <Button
          size="sm"
          variant="outline"
          className="bg-white/20 border-white/40 text-white hover:bg-white/30 hover:text-white"
          onClick={handleExit}
        >
          Ieși din impersonare
        </Button>
      </div>
    </div>
  );
}
